import { useEffect, useState } from "react";

/**
 * Forces a React component to rerender at a specified interval.
 *
 * @param seconds - The interval in seconds between rerenders. Must be greater than 0.
 *
 * @example
 * useTimedRerender(60); // Rerenders the component every minute
 */
export function useIntervalRerender(seconds: number) {
    const [, setTick] = useState(0);

    useEffect(() => {
        if (seconds <= 0) return;
        const interval = setInterval(() => setTick((t) => t + 1), seconds * 1000);
        return () => clearInterval(interval);
    }, [seconds]);
}
